import React from 'react'
import styles from './styles/info-box-container.module.scss'
import cx from 'classnames'

interface Props {
  className?: string
  as?: React.ElementType
}

const InfoBoxContainer: React.FC<Props> = ({ children, className, as: Tag = 'div' }) => {
  return <Tag className={cx(styles.infoBoxContainer, className)}>{children}</Tag>
}

export default InfoBoxContainer
